import { Text } from '@/components/ui/text';
import { Colors } from '@/lib/colorUtils';
import { cn } from '@/lib/styleUtils';
import type { ErrorBannerProps } from './ErrorBanner.types';

export const ErrorBanner: React.FC<ErrorBannerProps> = ({
  message,
  className,
  'data-cy': dataCy = 'error-banner',
}) => {
  if (!message) return null;

  return (
    <div
      role="alert"
      data-cy={dataCy}
      className={cn(
        'tw:p-base tw:bg-error/10 tw:border tw:border-solid tw:border-error tw:rounded-8',
        className
      )}
    >
      <Text size="14" color={Colors.colorBrandError}>
        {message}
      </Text>
    </div>
  );
};
